import Vue from 'vue';
import Vuex from 'vuex';

import { state as baseState } from './state';
import { getters } from './getters';
import { mutations } from './mutations';
import { createActions } from './actions'; /* eslint-disable-line */
import { Forms } from './modules/Forms';
import { Modals } from './modules/Modals';

Vue.use(Vuex);
export let store = {}; /* eslint-disable-line */
export const createStore = (router) => {
  const actions = createActions(router);

  store = new Vuex.Store({
    state: () => baseState,
    getters,
    mutations,
    actions,
    modules: {
      Forms,
      Modals,
    },
  });
  return store;
};
